import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from '../api';
import { endpoints } from '../endpoints';

import type { TProviderRole } from './types';

export const useUpdateProviderRole = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { primaryOrganizationId: orgId } = useSelector(
    (state: any) => state.login.user,
  );

  const providerRolePath = `${endpoints.videaInsights}/${orgId}/provider-role`;

  return useMutation({
    mutationFn: async (data: {
      providerId: number;
      providerRole: TProviderRole;
    }) => {
      const { providerId, providerRole } = data;

      await makeAPIRequestReactQuery(providerRolePath, {}, 'PUT', {
        headers: {
          Org: orgId,
        },
        data: {
          providerId,
          role: providerRole,
        },
      });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([providerRolePath]);
      onSuccess?.();
    },
  });
};
